export const globals = {
    cacheBoostingImages: "2025070200",
    cacheBoostingLocales: "2025070200",
}
